<template>
	<Bar 
    		ref="chart"
    		:data="computedData"
    		:options="options"
    		:plugins="plugins"
    	/>
</template>

<script>
import { Bar } from 'vue-chartjs'
import { 
		Utils, 
		Chart, 
		ArcElement, 
		LineController, 
		LineElement, 
		BarController, 
		BarElement, 
		PieController, 
		RadarController, 
		PointElement, 
		LinearScale, 
		RadialLinearScale, 
		CategoryScale, 
		TimeSeriesScale, 
		Title, 
		Legend, 
		Filler, 
		Tooltip 
	} from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'
Chart.register(LineController, ArcElement, LineElement, BarController, BarElement, PieController, RadarController, PointElement, LinearScale, RadialLinearScale, CategoryScale, TimeSeriesScale, Title, Legend, Filler, Tooltip, ChartDataLabels);

export default {
	name: 'BarChartSimple',
	components: {
		Bar
	},
	props: {
		data: {
			type: Object,
			default: {}
		},
		options: {
			type: Object,
			default: {}
		},
		plugins: {
			type: Array,
			default: []
		},
		hasData: {
			type: Boolean,
			default: false
		},
		feTheme: {
			type: Object,
			default: {
				charts_no_data_text: 'No data'
			}
		}
	},
	computed: {
		computedData() {
			if ( ! this.hasData ) {
				let data = JSON.parse(JSON.stringify(this.data));
				data.datasets = [
							{
								label: this.feTheme.charts_no_data_text,
								data: [1, 2, 3, 4, 2, 0],
								borderColor: '#c1d2c1',
			                    backgroundColor: '#d1d1d1',
							}
						]
				data.labels = ['', '', '', '', '', '']
				return data
			}
			return this.data
		}
	}
}
</script>